// ** React Import
import { useContext, useState, useEffect } from "react"
import { useReactOidc } from "@axa-fr/react-oidc-context"
import { useIntl } from "react-intl"
import { Button, Card, CardBody, Col, Form, FormGroup, Input, Label, Row } from "reactstrap"
import { useParams } from "react-router-dom"

// ** Custom Components
import Loading from "@views/common/Loading"
import Notification from "@views/common/Notification"
import { alertCustom } from "@views/common/NotificationClient"

// ** Context
import { IntlContext } from "@src/utility/context/Internationalization"

// ** Third Party Components
import { addCertificateOrgIframe, getChungThuSo } from "@services/CertificateService"
import { findOrganizationById } from "@services/OrganizationService"

// ** Styles
import "@styles/react/apps/app-users.scss"
import "@styles/react/libs/react-select/_react-select.scss"
import "@styles/react/libs/tables/react-dataTable-component.scss"

const AddCertificateTokenOrg = () => {
    const intl = useIntl()
    const { oidcUser, login } = useReactOidc()
    const intlContext = useContext(IntlContext)
    const { id, appId, messageId } = useParams()

    useEffect(() => {
        login()
    }, [])

    useEffect(() => {
        if (oidcUser) {
            login()
        }
    }, [oidcUser])

    const headers = {
        Authorization: `Bearer ${oidcUser && oidcUser.access_token}`,
        "Accept-Language": intlContext.locale
    }

    const [organization, setOrganization] = useState({})
    const [dataToken, setDataToken] = useState({})
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(null)
    const [success, setSuccess] = useState(null)
    const [saved, setSaved] = useState(false)

    useEffect(() => {
        intlContext.switchLanguage("vi")
    }, [intlContext])

    useEffect(() => {
        setLoading(true)
        findOrganizationById(headers, id)
            .then((res) => {
                setOrganization(res.data)
            })
            .catch((err) => {
                setError(err)
            })
            .finally(() => {
                setError(null)
                setLoading(false)
            })
    }, [id])

    const getDataToken = () => {
        getChungThuSo({
            mst: ""
        }).then((res) => {
            if (res.data.UID === organization?.tin || res.data.UID === organization?.budgetCode ||
                res.data.UID === organization?.decisionCode || res.data.UID === organization?.ircCode || res.data.UID === organization?.ssCode) {
                setDataToken(res.data)
            } else {
                alertCustom("error", `${intl.formatMessage({ id: "khongTrungOrg" })}`)
            }
        })
            .catch((err) => {
                alertCustom("error", `${intl.formatMessage({ id: "notToken" })}`)
            })
            .finally(() => {
                setError(null)
                setLoading(false)
            })
    }

    const buttonAddToken = () => {
        addCertificateOrgIframe(headers, organization.id, appId, messageId, {
            name: `${dataToken.Serial}.cer`,
            data: dataToken.Base64,
            apiKey: "",
            secretKey: "",
            sourceCertificate: "TOKEN"
        }).then((res) => {
            setSuccess(`${intl.formatMessage({ id: "addCerSuccess" })}`)
            window.parent.postMessage("success", "*")
            setSaved(true)
        })
            .catch((err) => {
                setError(err)
            })
            .finally(() => {
                setError(null)
                setLoading(false)
                setSaved(false)
            })
    }

    return (
        <Card className="mb-0">
            <CardBody>
                {loading && <Loading />}
                {error && <Notification data={{ error }} />}
                {success && saved && <Notification data={{ success }} />}
                <Row>
                    <Col md="12">
                        <Form>
                            <FormGroup row>
                                <Col sm={4}>
                                    <Button color="primary" onClick={getDataToken}>
                                        {intl.formatMessage({ id: "getData" })}
                                    </Button>
                                </Col>
                                <Col sm={4}>

                                </Col>
                                <Col sm={4}>

                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Label sm={3} className="label">
                                    {intl.formatMessage({ id: "serial" })}
                                </Label>
                                <Col sm={9}>
                                    <Input
                                        name="serial"
                                        type="text"
                                        value={dataToken.Serial}
                                        disabled
                                    />
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Label sm={3} className="label">
                                    {intl.formatMessage({ id: "soHuu" })}
                                </Label>
                                <Col sm={9}>
                                    <Input
                                        name="soHuu"
                                        type="text"
                                        value={dataToken.CN}
                                        disabled
                                    />
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Label sm={3} className="label">
                                    {intl.formatMessage({ id: "nhaCungCap" })}
                                </Label>
                                <Col sm={9}>
                                    <Input
                                        name="nhaCungCap"
                                        type="text"
                                        value={dataToken.IssuedBy}
                                        disabled
                                    />
                                </Col>
                            </FormGroup>

                            <FormGroup row>
                                <Label sm={3} className="label">
                                    {intl.formatMessage({ id: "ngayBatDau" })}
                                </Label>
                                <Col sm={3}>
                                    <Input
                                        name="ngayBatDau"
                                        type="text"
                                        value={dataToken.ValidFrom}
                                        disabled
                                    />
                                </Col>
                                <Label sm={3} className="label">
                                    {intl.formatMessage({ id: "ngayKetThuc" })}
                                </Label>
                                <Col sm={3}>
                                    <Input
                                        name="ngayKetThuc"
                                        type="text"
                                        value={dataToken.ValidTo}
                                        disabled
                                    />
                                </Col>
                            </FormGroup>
                        </Form>

                        {dataToken.Serial === undefined ? (
                            <Button color="primary" onClick={buttonAddToken} disabled>
                                {intl.formatMessage({ id: "add" })}
                            </Button>
                        ) : (
                            <Button color="primary" onClick={buttonAddToken}>
                                {intl.formatMessage({ id: "add" })}
                            </Button>
                        )}
                    </Col>
                </Row>
            </CardBody>
        </Card>
    )
}

export default AddCertificateTokenOrg